/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ButtonBase } from '../button/ButtonBase';
import { ArrowDown } from '../private/icons/ArrowDown';

const AccordionHeader = (props) => {

  const {
    children,
    className,
    disabled = false,
    expanded,
    toggle,
    ...other
  } = props;

  const handleChange = (event) => {
    if (toggle) {
      toggle(event);
    }
  };

  const buttonClass = [
    'sui-font-body sui-text-base sui-text-primary hover:sui-text-primary focus-visible:sui-text-inverse hover:sui-bg-subtle focus-visible:sui-bg-inverse',
    'sui-border-1 sui-border-primary hover:sui-border-1 hover:sui-border-hover focus-visible:sui-border-focus focus-visible:sui-border-4 sui-rounded-base focus-visible:sui-outline-0',
    'sui-group sui-peer',
    'sui-inline-flex sui-items-center sui-justify-between',
    'sui-px-4 sui-py-4 hover:sui-py-4 focus-visible:sui-py-[13px]',
    'sui-w-full sui-h-full',
  ].join(' ');

  const buttonClasses = classNames(buttonClass, {
    'sui-bg-button-inactive-primary sui-border-primary': disabled,
    'sui-border-primary': !disabled,
    'hover:sui-border-hover': !disabled,
    'sui-rounded-b-none': expanded
  }, className);

  const iconSpanClasses = classNames('sui-flex', {
    'group-focus-visible:sui-text-inverse group-hover:sui-text-brand': !disabled,
    'sui-text-inactive': disabled,
    'sui-text-primary': !expanded && !disabled,
    'hover:sui-text-brand': expanded
  });

  const iconClasses = classNames('sui-ml-4 sui-transition-transform sui-duration-250', {
    'sui-rotate-180': expanded
  });

  return (
    <ButtonBase
      onClick={handleChange}
      disabled={disabled}
      aria-disabled={disabled || false}
      aria-expanded={expanded || false}
      className={buttonClasses}
      unstyled
      {...other}
    >
      <span className="sui-text-ellipsis sui-whitespace-nowrap">
        {children || <span>&nbsp;</span>}
      </span>
      <span className={iconSpanClasses}>
        <ArrowDown className={iconClasses} size="small" />
      </span>
    </ButtonBase>
  );
};

AccordionHeader.displayName = 'AccordionSummary';

AccordionHeader.propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the AccordionBody is expanded.
   */
  expanded: PropTypes.bool,
  /**
   * @ignore
   */
  toggle: PropTypes.func
};

export { AccordionHeader };